import React from "react";
import Headers from "../../../components/Headers";
import { fetchIntegraDetails } from "../../../api/userInfo";
import {
  Input,
  Row,
  Col,
  Button,
  Table,
  Modal,
  Select,
  DatePicker,
} from "antd";
import "./index.scss";
const { RangePicker } = DatePicker;
const { Column } = Table;

const BreadCrumbData = [
  { path: "/page/ssry/userInfo", name: "试试如意" },
  { path: "/page/ssry/userInfo", name: "用户信息" },
  { path: "/page/ssry/interalDetails", name: "积分明细" },
];
class IntegraDetails extends React.Component {
  state = {
    listQuery: {
      pageNum: 1,
      pageSize: 10,
      numId: "",
      beginTime: "",
      endTime: "",
    },
    list: [],
    total: 0,
  };
  componentDidMount() {
    this.setState(
      {
        listQuery: {
          ...this.state.listQuery,
          numId: this.props.match.params.id,
        },
      },
      () => {
        this.getList();
      }
    );
  }
  getList = () => {
    fetchIntegraDetails(this.state.listQuery).then((res) => {
      if (res.success) {
        res.data.list.forEach((item, index) => {
          item.index = index;
        });
        this.setState({
          list: res.data.list,
          total: res.data.total,
        });
      }
    });
  };
  dateChange = (date, dateString) => {
    this.setState({
      listQuery: {
        ...this.state.listQuery,
        beginTime: dateString[0],
        endTime: dateString[1],
      },
    });
  };
  handleSearch = () => {
    this.setState(
      {
        listQuery: { ...this.state.listQuery, pageNum: 1 },
      },
      () => this.getList()
    );
  };
  render() {
    const { listQuery, list, total } = this.state;

    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="integraDetails_container">
          <div className="searchTop">
            <RangePicker
              className="marginR"
              onChange={this.dateChange}
              style={{ width: 250, marginRight: 10 }}
            />
            <Button type="primary" onClick={this.handleSearch}>
              搜索
            </Button>
          </div>
          <div className="content">
            <Table
              rowKey="index"
              dataSource={list}
              // locale={{ emptyText: "暂无商户" }}
              pagination={{
                showTotal: () => `共${total}条`,
                total: total,
                current: listQuery.pageNum,
                pageSize: listQuery.pageSize,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ["10", "20", "30", "40", "100"],
                onChange: (page, pageSize) => {
                  this.setState(
                    {
                      listQuery: { ...listQuery, pageNum: page },
                    },
                    () => this.getList()
                  );
                },
                onShowSizeChange: (current, pageSize) => {
                  this.setState(
                    {
                      listQuery: { ...listQuery, pageSize, pageNum: 1 },
                    },
                    () => this.getList()
                  );
                },
              }}
            >
              <Column title="时间" dataIndex="time" key="time" />
              <Column title="获取方式" dataIndex="reason" key="reason" />
              <Column title="获得积分" dataIndex="change" key="change" />
              <Column title="当前积分" dataIndex="after" key="after" />
            </Table>
          </div>
        </div>
      </div>
    );
  }
}
export default IntegraDetails;
